import styled, { css } from 'styled-components';
import * as Dialog from '@radix-ui/react-dialog';

export const WrapperInvoiceDetail = styled.div`
  display: flex;
  padding: 16px;

  p {
    font-size: 16px;
  }
  span {
    font-size: 16px;
    font-weight: 500;
    color: #808080;
  }
`;
export const HistoryItem = styled.div`
  display: flex;
  padding: 16px;
  gap: 8px;
  border: 1px solid #e7e9ec;
  border-radius: 8px;
  margin-bottom: 16px;
  flex-direction: column;
  &:last-child {
    margin-bottom: 32px;
  }
`;
export const ListContainer = styled.div`
  padding-bottom: 16px;
  @supports (padding: max(0px)) {
    padding-bottom: max(16px, env(safe-area-inset-bottom));
  }
`;
export const Broker = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #888888;
`;
export const Description = styled.span<{ isBold?: boolean }>`
  font-size: 16px;
  color: #333;
  font-weight: ${({ isBold }) => (isBold ? 700 : 500)};
`;
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 colunas */
  gap: 8px; /* Espaçamento entre os itens */

  @media (max-width: 800px) {
    grid-template-columns: 1fr; /* 1 coluna quando a largura for menor que 800px */
  }
`;
export const SubTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #808080;
`;
export const Container = styled.div`
  display: flex;
`;
export const Box = styled.div`
  border-radius: 12px;
  border: 1px solid #d8d8d8;
  width: 100%;
`;
export const BoxDownload = styled.div`
  border-bottom: 1px solid #d8d8d8;
  padding: 16px 24px;
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: space-between;
  p {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 0;
  }
  span {
    font-size: 12px;
    font-weight: 500;
    color: #808080;
  }
`;
export const Overlay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 2;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  ${({ theme }) => css`
    width: 60rem;
    background: ${theme.colors.neutral.neutral0};
    border-radius: 8px;
    box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.08);
    padding: 3.2rem;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.xlarge};
    font-weight: ${theme.font.semiBold};
    color: ${theme.colors.neutral.neutral100};
    padding-left: 16px;
  `}
`;

export const CloseButton = styled(Dialog.Close)`
  ${({ theme }) => css`
    position: absolute;
    background: transparent;
    border: 0;
    top: 4rem;
    right: 3.5rem;
    line-height: 0;
    cursor: pointer;
    color: ${theme.colors.neutral.neutral100};
  `}
`;

// export const BaseListModal = styled.ul`
//   ${({ theme }) => css`

//   `}
// `

export const ContentDetails = styled.div`
  ${({ theme }) => css`
    padding: 16px;
    header {
      display: grid;
      grid-template-columns: 50% 25% 25%;
      font-size: ${theme.font.sizes.medium};
      color: ${theme.colors.neutral.neutral50};
      margin-bottom: 1rem;
    }
    .contentPlan {
      margin: 2rem 0 2rem 0;
    }
    ul + ul {
      margin-top: 2rem;
    }
    .planName {
      display: grid;
      grid-template-columns: 50% 25% 25%;

      grid-template-rows: min-content;
      row-gap: 1.6rem;
      list-style: none;
      font-size: ${theme.font.sizes.medium};
      padding-left: 0;
      &-row {
        color: ${theme.colors.neutral.neutral100};
        font-weight: ${theme.font.normal};
        &__value {
          color: ${theme.colors.neutral.neutral100};
          font-weight: ${theme.font.bold};
        }
      }
    }
    .additionalPlan {
      display: grid;
      grid-template-columns: 50% 25% 25%;
      grid-template-rows: min-content;
      row-gap: 1.6rem;
      list-style: none;
      font-size: ${theme.font.sizes.medium};
      padding-left: 0;
      &-row {
        color: ${theme.colors.neutral.neutral50};
        &__value {
          color: ${theme.colors.neutral.neutral50};
          font-weight: ${theme.font.bold};
        }
      }
    }
    footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin: inherit;

      span {
        font-size: ${theme.font.sizes.medium};
        font-weight: ${theme.font.bold};
        color: ${theme.colors.neutral.neutral120};
      }
      > button {
        justify-content: flex-start;
      }
    }
  `}
`;
